import React from 'react';

class Sidemenu extends React.Component {
  renderItems () {
    return this.props.menu.map((e,i) => {
        return <li key={i} className="sidemenu-item"><a href={e.link}>{e.label}</a></li>
    })
  }
  render () {
    return (
        <div className="sidemenu">
            <div className="sidemenu-title">{this.props.title}</div>
            <ul>
                {this.renderItems()}
            </ul>
        </div>
      )
  }
}

export default Sidemenu;